import { Record } from 'immutable';
import { schema } from 'normalizr';

export const PendingUnitCommand = new Record({
  id: undefined,
  command: undefined,
  data: undefined,
  created_time: undefined,
  processed_time: undefined,
  acknowledged_time: undefined,
  processed: undefined,
  success: undefined,
  error_code: undefined,
  sequence_number: undefined,
  site: undefined,
  user: undefined,
  bulk_command: null,
});

export const pendingUnitCommandSchema = new schema.Entity('pendingUnitCommands');

// for reading in nested models, object with { field: schema }
// pendingUnitCommandSchema.define({  });
